import React, { useRef, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  Cannada,
  IndianFlag,
  Mexico,
  UAE,
  UnitedStatsFlag,
  Uruguay,
} from "../../assets/svg";
import Globe from "react-globe.gl";
import { Link } from "react-router-dom";
import { GoArrowRight } from "react-icons/go";
import SectionHeader from "../sectionHeader";
import SectionSubHeader from "../sectionSubHeader";

const OurLocation = ({viewMaps, showAddress}) => {
  const globeRef = useRef(null);

  useEffect(() => {
    if (globeRef.current) {
      setTimeout(() => {
        globeRef.current.controls().autoRotate = true;
        globeRef.current.controls().autoRotateSpeed = 0.8;
        globeRef.current.controls().enableZoom = true;
        globeRef.current.controls().enableRotate = true;
        globeRef.current.controls().enablePan = true;
        globeRef.current.pointOfView({ altitude: 1.5 }, 1000);
      }, 500); // Add a slight delay
    }
  }, []);
  
  

  return (
    <>
      <div className="our-location">
      <Container>
          <Row>
            <Col>
              <div className="location-header">
              <img
  className="our-location-text"
  src="/images/our-location-text.svg"
  alt="our-location"
/>
              </div>
            </Col>
          </Row>
        </Container>
        <img
          className="globe"
          src="images/our-location-globe.webp"
          alt="our-location-globe"
        />
      </div>
      <Container className="location-row">
        <Row>
          <Col lg={4} md={6}>
            <div className="loaction-card">
              <p>
                India &nbsp;
                <span>
                  <IndianFlag />
                </span>
              </p>
              <p>Bangalore & Salem</p>
              {
                viewMaps && (
                  <Link
                  className="location-maps"
                  target="_blank"
                  rel="noreferrer"
                  to={"https://maps.app.goo.gl/wB2zohpoUae9FXWc6"}
                >
                  VIEW ON MAP
                  <span>
                    <GoArrowRight />
                  </span>
                </Link>
                )
              }
              {
                showAddress && (
                  <h6 className="showAddress">
                    No.43/4, 1st Floor,  Urban Vault Citrine, Sanjeevini Nagar,  Hebbal Village, Bellary Road,  Bengaluru - 560092  
                  </h6>
                )
              }
             

              <img
                className="card-image small-img"
                src="/images/south.png"
                alt="karnataka-selam-india"
              />
            </div>
          </Col>
          <Col lg={4} md={6}>
            <div className="loaction-card">
              <p>
                Canada &nbsp;
                <span>
                  <Cannada />
                </span>
              </p>
              <p>Ontario</p>
              {
                viewMaps && (
              
              <Link
                className="location-maps"
                target="_blank"
                rel="noreferrer"
                to={"https://maps.app.goo.gl/ujXR3UcVmkkWkADu7"}
              >
                VIEW ON MAP
                <span>
                  <GoArrowRight />
                </span>
              </Link> )
              }
{
                showAddress && (
                  <h6 className="showAddress">
                    366 - 1720 Howard Ave, Windsor, ON, N8X 5A6, Canada
                  </h6>
                )
              }
              <img
                className="card-image"
                src="/images/toronto-cn-tower.png"
                alt="karnataka-selam-india"
              />
            </div>
          </Col>
          <Col lg={4} md={6}>
            <div className="loaction-card">
              <p>
                USA &nbsp;
                <span>
                  <UnitedStatsFlag />
                </span>
              </p>
              <p>Schaumburg,</p>
              {
                viewMaps && (
              <Link
                className="location-maps"
                target="_blank"
                rel="noreferrer"
                to={"https://maps.app.goo.gl/S4QzvrpG2xZqaeHw6"}
              >
                VIEW ON MAP
                <span>
                  <GoArrowRight />
                </span>
              </Link>
              )
            }
            {
                showAddress && (
                  <h6 className="showAddress">
                   1750 E Golf Rd, Suite 224, Schaumburg, IL 60173, USA
                  </h6>
                )
              }
              <img
                className="card-image"
                src="/images/schaumburg-USA.webp"
                alt="schaumburg-USA"
              />
            </div>
          </Col>
          <Col lg={4} md={6}>
            <div className="loaction-card">
              <p>
                Uruguay &nbsp;{" "}
                <span>
                  <Uruguay />
                </span>
              </p>
              <p>Montevideo,</p>
              {
                viewMaps && (
              
              <Link
                className="location-maps"
                target="_blank"
                rel="noreferrer"
                to={"https://maps.app.goo.gl/BSTtCeLQEm49VzAX7"}
              >
                VIEW ON MAP
                <span>
                  <GoArrowRight />
                </span>
              </Link>)}
              {
                showAddress && (
                  <h6 className="showAddress">
                     World Trade Center Montevideo, Av. Dr.Luis a. de Herrera 1248, Torre III, Piso 12, Uruguay
                  </h6>
                )
              }
              <img
                className="card-image"
                src="/images/montevideo-uruguay.webp"
                alt="montevideo-uruguay"
              />
            </div>
          </Col>

          <Col lg={4} md={6}>
            <div className="loaction-card">
              <p>
                Mexico &nbsp;
                <span>
                  <Mexico />
                </span>
              </p>
              <p>Huexotitla,</p>
              {
                viewMaps && (
              
              <Link
                className="location-maps"
                target="_blank"
                rel="noreferrer"
                to={"https://maps.app.goo.gl/U9yAAx6sGniMPv85A"}
              >
                VIEW ON MAP
                <span>
                  <GoArrowRight />
                </span>
              </Link>)}
              {
                showAddress && (
                  <h6 className="showAddress">
                   Retorno Osa Menor 2, Ciudad Judicial, 72821 San Andrés Cholula, PUE, Mexico
                  </h6>
                )
              }
              <img
                className="card-image"
                src="/images/Huexotitla-Mexico.webp"
                alt="Huexotitla-Mexico"
              />
            </div>
          </Col>
          <Col lg={4} md={6}>
            <div className="loaction-card">
              <p>
                UAE &nbsp;{" "}
                <span>
                  <UAE />
                </span>
              </p>
              <p>Sharjah,</p>
              {
                viewMaps && (
              
              <Link
                className="location-maps"
                target="_blank"
                rel="noreferrer"
                to={"https://maps.app.goo.gl/gdCRfnvzzETUXEnT7"}
              >
                VIEW ON MAP
                <span>
                  <GoArrowRight />
                </span>
              </Link>)}
              {
                showAddress && (
                  <h6 className="showAddress">
                     SPC Free Zone, E311, Sheikh Mohammed Bin Zayed Rd, Al Zahia, Sharjah, U.A.E.
                  </h6>
                )
              }
              <img
                className="card-image medium-img"
                src="/images/sharjah-UAE.webp"
                alt="sharjah-UAE"
              />
            </div>
          </Col>
        </Row>
        
      </Container>
    </>
  );
};

export default OurLocation;
{
  /* <img
          className="globe"
          src="/images/our-location-globe.webp"
          alt="our-location-globe"
        /> */
}

{
  /* <Container>
          <Row>
            <Col>
              <div className="location-header">
                <SectionHeader mainText1="OUR" mainText2="FOOTPRINTS" />
                <SectionSubHeader headerText="LOCATIONS" />
              </div>
            </Col>
          </Row>
        </Container> */
}


{/* <div className="animated-globe">

<Globe
ref={globeRef}
backgroundColor="rgba(0,0,0,0)"
globeImageUrl="//unpkg.com/three-globe/example/img/earth-blue-marble.jpg"
bumpImageUrl="//unpkg.com/three-globe/example/img/earth-topology.png"
style={{ width: "100%", height: "500px" }} // Set a size
onGlobeReady={() => {
console.log('Globe is ready');
}}
/>

</div> */}